import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  width: 100%;
  margin-top: 40px;

  ${screen.md} {
    margin-top: 80px;
  }
`;

export const ScaleLabel = styled.p`
  font-family: ${getToken('font-family-default')};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  color: ${homeColor.muted2};
  margin: 0;
`;

export const ScaleRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 26px;
  width: 100%;

  ${screen.md} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const Stat = styled.div`
  text-align: center;
`;

export const StatValue = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: 42px;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  color: ${homeColor.white};

  ${screen.md} {
    font-size: 36px;
  }

  ${screen.lg} {
    font-size: 50px;
  }
`;

export const StatUnit = styled.span`
  color: ${homeColor.green};
`;

export const StatLabel = styled.div`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted};
  font-size: 13px;
  margin-top: 4px;
  max-width: 22ch;
  margin-left: auto;
  margin-right: auto;

  ${screen.md} {
    font-size: 11px;
  }

  ${screen.lg} {
    font-size: 13px;
  }
`;
